export var DiffChangeType;
(function (DiffChangeType) {
    DiffChangeType["DIFF_CHANGE_TYPE_ADDED"] = "ADDED";
    DiffChangeType["DIFF_CHANGE_TYPE_MODIFIED"] = "MODIFIED";
    DiffChangeType["DIFF_CHANGE_TYPE_REMOVED"] = "REMOVED";
    DiffChangeType["DIFF_CHANGE_TYPE_RENAMED"] = "RENAMED";
})(DiffChangeType || (DiffChangeType = {}));
